import Component from "@ember/component"
import { inject as service } from "@ember/service"
import type EmberStore from "cc-frontend/services/ember-store"
import type ModalManager from "cc-frontend/services/modal-manager"

export default class PrintPaywallComponent extends Component {
  // Args

  // Props
  currentStep: number = 0
  isOpen: boolean = false

  // Services
  @service("ember-store") store!: EmberStore
  @service modalManager!: ModalManager
}
